import React from 'react';
import { Link } from 'react-router-dom';
import notFoundImg from '../../images/error-404.png';
import './page-not-found.scss';
const PageNotFound = () => {
    return (
        <div className="not-found-wrapper">
            <div>
                <p>Page not found <Link to='/projects'>Go back to projects</Link></p>
                <img src={notFoundImg} alt="page not found" />
            </div>
        </div>
    );
};
export default PageNotFound;
